/**
 * @generated SignedSource<<a189206a763587bd203cc91283eba465>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReturningBuyerDeliveryOptionsView_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_transaction" | "useUpdateShipmentQuote_transaction">;
  readonly " $fragmentType": "CheckoutReturningBuyerDeliveryOptionsView_transaction";
};
export type CheckoutReturningBuyerDeliveryOptionsView_transaction$key = {
  readonly " $data"?: CheckoutReturningBuyerDeliveryOptionsView_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReturningBuyerDeliveryOptionsView_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReturningBuyerDeliveryOptionsView_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useUpdateShipmentQuote_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "e1b016b5ad74c1a5420e945846769b3d";

export default node;
